import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

import ReportsWrapper from './components/ReportsWrapper.vue';

const Index = () => import('./Index.vue');
const AgentReportsIndex = () => import('./AgentReportsIndex.vue');
const InboxReportsIndex = () => import('./InboxReportsIndex.vue');
const TeamReportsIndex = () => import('./TeamReportsIndex.vue');
const LabelReportsIndex = () => import('./LabelReportsIndex.vue');
const AgentReportsShow = () => import('./AgentReportsShow.vue');
const InboxReportsShow = () => import('./InboxReportsShow.vue');
const TeamReportsShow = () => import('./TeamReportsShow.vue');
const LabelReportsShow = () => import('./LabelReportsShow.vue');
// Legacy report components removed — old routes redirect to revised versions
const CsatResponses = () => import('./CsatResponses.vue');
const BotReports = () => import('./BotReports.vue');
const LiveReports = () => import('./LiveReports.vue');
const SLAReports = () => import('./SLAReports.vue');
const CrmReportsDashboard = () => import('./CrmReportsDashboard.vue');
const AgentAvailabilityReports = () => import('./AgentAvailabilityReports.vue');
const AgentAvailabilityShow = () => import('./AgentAvailabilityShow.vue');

const meta = {
  featureFlag: FEATURE_FLAGS.REPORTS,
  permissions: ['administrator', 'report_manage'],
};

// Old routes redirect to revised versions
const oldReportRoutes = [
  {
    path: 'agent',
    redirect: to => ({ name: 'agent_reports_index', params: to.params }),
  },
  {
    path: 'inboxes',
    redirect: to => ({ name: 'inbox_reports_index', params: to.params }),
  },
  {
    path: 'label',
    redirect: to => ({ name: 'label_reports_index', params: to.params }),
  },
  {
    path: 'teams',
    redirect: to => ({ name: 'team_reports_index', params: to.params }),
  },
];

const revisedReportRoutes = [
  {
    path: 'agents_overview',
    name: 'agent_reports_index',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: AgentReportsIndex,
  },
  {
    path: 'agents/:id',
    name: 'agent_reports_show',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: AgentReportsShow,
  },

  {
    path: 'inboxes_overview',
    name: 'inbox_reports_index',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: InboxReportsIndex,
  },
  {
    path: 'inboxes/:id',
    name: 'inbox_reports_show',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: InboxReportsShow,
  },
  {
    path: 'teams_overview',
    name: 'team_reports_index',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: TeamReportsIndex,
  },
  {
    path: 'teams/:id',
    name: 'team_reports_show',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: TeamReportsShow,
  },
  {
    path: 'labels_overview',
    name: 'label_reports_index',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: LabelReportsIndex,
  },
  {
    path: 'labels/:id',
    name: 'label_reports_show',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: LabelReportsShow,
  },
];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: ReportsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'account_overview_reports', params: to.params };
          },
        },
        {
          path: 'overview',
          name: 'account_overview_reports',
          meta,
          component: LiveReports,
        },
        {
          path: 'conversation',
          name: 'conversation_reports',
          meta,
          component: Index,
        },
        ...oldReportRoutes,
        ...revisedReportRoutes,
        {
          path: 'availability',
          name: 'agent_availability_reports',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: AgentAvailabilityReports,
        },
        {
          path: 'availability/:id',
          name: 'agent_availability_show',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: AgentAvailabilityShow,
        },
        {
          path: 'sla',
          name: 'sla_reports',
          meta,
          component: SLAReports,
        },
        {
          path: 'csat',
          name: 'csat_reports',
          meta,
          component: CsatResponses,
        },
        {
          path: 'bot',
          name: 'bot_reports',
          meta,
          component: BotReports,
        },
        {
          path: 'crm',
          name: 'crm_reports',
          meta,
          component: CrmReportsDashboard,
        },
      ],
    },
  ],
};
